// focus 主服务 快速创建用户 创建团队
import BaseService from "./BaseService";
import {
  ApprovaTeamUserInfo,
  InviteUserInfo,
  SendJoinApproveRes,
  CreateTeamAndEmployee,
  TeamUserInfo,
  UserTeamInfoInterface
} from "@/types/LoginPage";
import { ICommonConfig } from "@/models/user";
import { createTeamParams } from "@/components/LoginComp/forms/JoinMe/CreateTeam";

export type ApprovaTeamUserInfoList = ApprovaTeamUserInfo[];

export interface IVerifyThirdTokenLoginReq {
  token: string;
  appId: string;
}

class FocusService extends BaseService {
  token = "";
  createUser(params: { mobile: string; userName: string; authCode: string; countryCode?: string }) {
    return this.fetch("focus", "createUser", {
      ...params
    });
  }

  setToken(token: string) {
    this.token = token;
  }

  customHeaders() {
    return {
      "x-token": this.token
    };
  }

  getApproveStatus() {
    return this.fetch<ApprovaTeamUserInfoList>(
      "focus",
      "joinTeamRecord",
      {},
      { headers: this.customHeaders(), ignoreErrMessageAlert: true }
    );
  }

  getInviteUserByTeamCode(params: { teamCode: string }) {
    return this.fetch<InviteUserInfo>(
      "focus",
      "getInviteUserByTeamCode",
      {
        ...params
      },
      {
        headers: this.customHeaders(),
        ignoreErrMessageAlert: true
      }
    );
  }
  // 验证码校验
  checkInviteCodeByTeamCode(params: { inviteCode: string; inviteUserId: string }) {
    return this.fetch<InviteUserInfo>(
      "focus",
      "checkInviteCode",
      {
        ...params
      },
      {
        headers: this.customHeaders(),
        ignoreErrMessageAlert: true
      }
    );
  }
  joinPersonalTeam(params: { userId: string; userName: string }) {
    return this.fetch<TeamUserInfo>(
      "focus",
      "joinPersonalTeam",
      {
        ...params
      },
      { headers: this.customHeaders(), ignoreErrMessageAlert: true }
    );
  }
  sendJoinApprove(params: { inviteTeamId: string; inviteUserId: string; inviteUserName?: string }) {
    return this.fetch<SendJoinApproveRes>(
      "focus",
      "sendJoinApprove",
      {
        ...params
      },
      { headers: this.customHeaders() }
    );
  }
  sendJoinTeamApprove(params: {
    inviteCode: string;
    inviteUserId: string;
    name?: string;
    joinType: number; // 固定值
  }) {
    return this.fetch<SendJoinApproveRes>(
      "focus",
      "joinTeamJQT",
      {
        ...params
      },
      { headers: this.customHeaders() }
    );
  }

  createTeamAndEmployee(params: {
    mobile: string;
    userTeamName: string;
    teamName: string;
    countryCode: string;
  }) {
    return this.fetch<CreateTeamAndEmployee>(
      "focus",
      "createTeamAndEmployee",
      {
        ...params
      },
      { headers: this.customHeaders() }
    );
  }
  createTeamAndEmployeeNew(params: createTeamParams) {
    return this.fetch<CreateTeamAndEmployee>(
      "ebook",
      "createTeam",
      {
        ...params
      },
      { headers: this.customHeaders(), ignoreErrMessageAlert: true }
    );
  }
  validateTeamCount(params: createTeamParams) {
    return this.fetch<CreateTeamAndEmployee>(
      "ebook",
      "validateTeamCount",
      {
        ...params
      },
      { headers: this.customHeaders(), ignoreErrMessageAlert: true }
    );
  }
  checkPersonalTeam() {
    return this.fetch<{
      hasPersonalTeam: boolean;
    }>(
      "focus",
      "checkPersonalTeam",
      {},
      { headers: this.customHeaders(), ignoreErrMessageAlert: true }
    );
  }
  getCreateTeamOptions(params: any) {
    return this.fetch<CreateTeamAndEmployee>(
      "ebook",
      "getAllCreateTeamEnums",
      { ...params },
      { headers: this.customHeaders() }
    );
  }
  getUserTeamInfo() {
    return this.fetch<UserTeamInfoInterface>(
      "focus",
      "getUserTeamInfo",
      {},
      { headers: this.customHeaders() }
    );
  }
  commonConfig(params?: any) {
    return this.fetch<ICommonConfig>("focus", "commonConfig", params);
  }
  // 三方token验证
  verifyThirdTokenLogin(body: IVerifyThirdTokenLoginReq): Promise<any> {
    return this.fetch("login", "verifyThirdTokenLogin", body, { headers: this.customHeaders() });
  }
}

export default FocusService;
